import { Link, useLocation } from 'react-router-dom';
import { Button } from 'src/registry/ui/Button';

type SidebarButtonProps = {
    urlLink: string;
    title: string;
    hasPermission?: boolean;
    additionalActivePaths?: string[];
};

const SidebarButton = ({ urlLink, title, hasPermission = true, additionalActivePaths = [] }: SidebarButtonProps) => {
    const { pathname } = useLocation();

    return (
        hasPermission && (
            <Button
                asChild
                className="h-8 justify-start pl-2"
                variant={[urlLink, ...additionalActivePaths].includes(pathname) ? 'activeGray' : 'link'}
            >
                <Link to={urlLink} style={{ textDecoration: 'none' }}>
                    {title}
                </Link>
            </Button>
        )
    );
};

export default SidebarButton;
